// extracted by mini-css-extract-plugin
export default {"menu":"MenuCategoriesList_menu__JBX29","centered":"MenuCategoriesList_centered__JycFS","message":"MenuCategoriesList_message__bhvXO"};